<template>
  <div>
    <route-tabs-component :tabs="tabs" aria-label="customization.settings"></route-tabs-component>
    <router-view></router-view>
  </div>
</template>

<script>
import RouteTabsComponent from "@/components/navigation/RouteTabsComponent";

/* Personalización › Ajustes: dominio, idioma y scripts (los scripts, lo más delicado, al final). */
export default {
  name: "AcademySettingsComponent",
  components: {
    RouteTabsComponent,
  },
  data() {
    return {
      tabs: [
        { to: { name: 'academy.domain' }, label: 'customization.domain' },
        { to: { name: 'academy.lang' }, label: 'customization.lang' },
        { to: { name: 'academy.scripts' }, label: 'marketing.scripts' },
      ]
    }
  },
}
</script>
